/* eslint-disable prettier/prettier */
import React from 'react';
import { Box } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { PeriodType } from '../../hooks/useTaxFilters';

interface PeriodOption {
  label: string;
  value: PeriodType;
}

interface PeriodButtonsProps {
  selectedPeriod: PeriodType;
  onQuarterClick: () => void;
  onSemesterClick: () => void;
  onYearClick: () => void;
  onCurrentYearClick: () => void;
  onLastYearClick: () => void;
}

const periodOptions: PeriodOption[] = [
  { label: 'Trimestral', value: 'quarter' },
  { label: 'Semestral', value: 'semester' },
  { label: '12 Meses', value: 'year' },
  { label: 'Ano Atual', value: 'current_year' },
  { label: 'Ano Anterior', value: 'last_year' },
];

export function PeriodButtonsMontly({
  selectedPeriod,
  onQuarterClick,
  onSemesterClick,
  onYearClick,
  onCurrentYearClick,
  onLastYearClick,
}: PeriodButtonsProps) {
  const handleChange = (option: PeriodOption | null) => {
    if (!option) return;

    switch (option.value) {
      case 'quarter':
        onQuarterClick();
        break;
      case 'semester':
        onSemesterClick();
        break;
      case 'year':
        onYearClick();
        break;
      case 'current_year':
        onCurrentYearClick();
        break;
      case 'last_year':
        onLastYearClick();
        break;
      default:
        break;
    }
  };

  const selectedOption = periodOptions.find(opt => opt.value === selectedPeriod) || null;

  return (
    <Box minW="180px">
      <Select<PeriodOption>
        placeholder="Selecione o período"
        options={periodOptions}
        value={selectedOption}
        onChange={handleChange}
        size="sm"
        chakraStyles={{
          control: provided => ({
            ...provided,
            minHeight: '40px',
            height: '40px',
          }),
          valueContainer: provided => ({
            ...provided,
            height: '40px',
            padding: '0 8px',
          }),
          input: provided => ({
            ...provided,
            margin: '0',
            padding: '0',
          }),
          indicatorsContainer: provided => ({
            ...provided,
            height: '40px',
          }),
        }}
      />
    </Box>
  );
}
